import {adicRestApi, adicRestApiForumUrl} from '../index';

export const getAdGlobalMainList = async (globalUrl) => {
  const url = adicRestApiForumUrl
    .segment("/global/list")
    .query(
      {
        url: globalUrl
      }
    )
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getAdGlobalList = async (category, pageSize, pageNumber) => {
  const url = adicRestApiForumUrl
    .segment("/:category/list")
    .param(category)
    .query(pageSize, pageNumber)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getAdGlobalDetail = async (category, ukey) => {
  const url = adicRestApiForumUrl
    .segment("/:category/info")
    .param({category : category})
    .query({ukey : ukey})
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getAdGlobalVideoDetail = async (ukey) => {
  const url = adicRestApiForumUrl
    .segment("/video/info")
    .query(ukey)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};

export const getAdGlobalTextDetail = async (ukey) => {
  const url = adicRestApiForumUrl
    .segment("/text/info")
    .query(ukey)
    .toString();

  const { data } = await adicRestApi.get(url);
  return data;
};
